export default "__VITE_ASSET__Bt18YygM__"